module.exports = __webpack_public_path__ + "img/logo.6a1a83ba.png";